import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../utils/QAPlogo-Photoroom.png";

function LandingNav() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");

    const handler = () => {
      setIsMobile(media.matches);
      if (!media.matches) setMenuOpen(false);
    };

    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const handleBookDemo = () => {
    scrollTo("contact");
  };

  return (
    <nav className="landing-navbar">
      {/* ===== LEFT SIDE (logo + desktop links) ===== */}
      <div className="landing-nav-left">
        <img
          src={logo}
          alt="QAP Financials"
          className="landing-nav-logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />

        {!isMobile && (
          <>
            <a onClick={() => scrollTo("why")}>Why QAP</a>
            <a onClick={() => scrollTo("how")}>How It Works</a>
            <a onClick={() => scrollTo("about")}>About Us</a>
            <a onClick={() => scrollTo("contact")}>Contact Us</a>
          </>
        )}
      </div>

      {/* ===== RIGHT SIDE ===== */}
      {!isMobile ? (
        <div className="landing-nav-right">
          <span className="landing-login-link" onClick={() => navigate("/login")}>
            Login
          </span>
          <button className="landing-demo-btn" onClick={handleBookDemo}>
            Book Demo
          </button>
        </div>
      ) : (
        <>
          <div
            className="mobile-menu-btn"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            ☰
          </div>

          {menuOpen && (
            <div className="mobile-menu">
              <a onClick={() => scrollTo("why")}>Why QAP</a>
              <a onClick={() => scrollTo("how")}>How It Works</a>
              <a onClick={() => scrollTo("about")}>About Us</a>
              <a onClick={() => scrollTo("contact")}>Contact Us</a>
              <a onClick={() => navigate("/login")}>Login</a>
              <button className="landing-demo-btn" onClick={handleBookDemo}>
                Book Demo
              </button>
            </div>
          )}
        </>
      )}
    </nav>
  );
}

export default LandingNav;
